import React from 'react';

export interface CardProps {
  children: React.ReactNode;
  className?: string;
  padding?: 'none' | 'sm' | 'md' | 'lg';
  hover?: boolean;
  onClick?: () => void;
}

const Card: React.FC<CardProps> = ({
  children,
  className = '',
  padding = 'md',
  hover = false,
  onClick,
}) => {
  const paddingStyles = {
    none: '',
    sm: 'p-4 sm:p-5',
    md: 'p-5 sm:p-6',
    lg: 'p-6 sm:p-8',
  };
  
  const hoverStyles = hover || onClick 
    ? 'hover:shadow-xl hover:-translate-y-1 transition-all duration-300 ease-out cursor-pointer active:scale-[0.98]' 
    : 'transition-shadow duration-200';
  const clickStyles = onClick ? 'cursor-pointer' : '';
  
  return (
    <div
      className={`
        bg-white rounded-2xl
        shadow-sm hover:shadow-md
        border border-gray-200/80
        backdrop-blur-sm
        ${paddingStyles[padding]}
        ${hoverStyles}
        ${clickStyles}
        ${className}
      `.replace(/\s+/g, ' ').trim()}
      onClick={onClick}
      role={onClick ? 'button' : undefined}
      tabIndex={onClick ? 0 : undefined}
      onKeyDown={onClick ? (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          onClick();
        }
      } : undefined}
    >
      {children}
    </div>
  );
};

export default Card;

